import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PATH_ROOT } from '../../paths';
import {
  passwordRequest,
  fetchMfaStatus,
  validateUsernameRequest,
  submitForgotPasswordChange,
  clearError,
} from '../../actions';
import Username from './Username';
import PasswordMFA from './PasswordMFA';

const styles = {
  header: {
    paddingBottom: '20px',
  },
};

class ForgotContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      errorUsername: '',
      password: '',
      errorPassword: '',
      passwordConfirmation: '',
      errorPasswordConfirmation: '',
      mfaCode: '',
      errorMfaCode: '',
      error: '',
      floatTextSet: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.mfaStatus) {
      this.props.history.push(PATH_ROOT);
    }

    this.props.clearError();
  }

  handleSubmitUser = e => {
    e.preventDefault();

    const username = this.state.username.trim();

    if (!username) {
      this.setState({ errorUsername: 'Username required' });
    } else {
      this.setState({ errorUsername: '' });
      this.props.validateUsernameRequest(username);
    }
  };

  handleSubmitPassword = e => {
    e.preventDefault();

    const username = this.state.username.trim();
    const mfaCode = this.state.mfaCode.trim();
    const password = this.state.password.trim();
    const passwordConfirmation = this.state.passwordConfirmation.trim();

    if (!mfaCode || !password || !passwordConfirmation || password !== passwordConfirmation) {
      if (!mfaCode) {
        this.setState({ errorMfaCode: 'Verification Code required' });
      } else {
        this.setState({ errorMfaCode: '' });
      }

      if (!password) {
        this.setState({ errorPassword: 'Password required' });
      } else {
        this.setState({ errorPassword: '' });
      }

      if (!passwordConfirmation || password !== passwordConfirmation) {
        if (!passwordConfirmation) {
          this.setState({
            errorPasswordConfirmation: 'Password Confirmation required',
          });
        } else if (password !== passwordConfirmation) {
          this.setState({
            errorPasswordConfirmation: 'Password Confirmation doesnt match',
          });
        } else {
          this.setState({ errorPasswordConfirmation: '' });
        }
      } else {
        this.setState({ errorPasswordConfirmation: '' });
      }
    } else {
      this.props.submitForgotPasswordChange({
        username,
        password,
        mfaCode,
      });
    }
  };

  handleUsernameChange = e => {
    this.setState({ username: e.target.value });

    if (this.state.errorUsername) {
      this.setState({ errorUsername: '' });
    }
  };

  handlePasswordChange = e => {
    this.setState({ password: e.target.value });

    if (this.state.errorPassword) {
      this.setState({ errorPassword: '' });
    }
  };

  handlePasswordConfirmationChange = e => {
    this.setState({ passwordConfirmation: e.target.value });

    if (this.state.errorPasswordConfirmation) {
      this.setState({ errorPasswordConfirmation: '' });
    }
  };

  handleMfaCodeChange = e => {
    this.setState({ mfaCode: e.target.value });

    if (this.state.errorMfaCode) {
      this.setState({ errorMfaCode: '' });
    }
  };

  renderLogo = () => {
    const src = localStorage.logo ? localStorage.logo : `/Home/GetLogo`;

    return <img src={src} height="40" alt="logo" style={styles.header} />;
  };

  render() {
    const { errors, currentlySending, loading, mfaChallenge } = this.props;

    if (mfaChallenge) {
      return (
        <PasswordMFA
          errors={errors}
          currentlySending={currentlySending}
          loading={loading}
          handleSubmit={this.handleSubmitPassword}
          handlePasswordChange={this.handlePasswordChange}
          handlePasswordConfirmationChange={this.handlePasswordConfirmationChange}
          handleMfaCodeChange={this.handleMfaCodeChange}
          mfaCode={this.state.mfaCode}
          errorMfaCode={this.state.errorMfaCode}
          password={this.state.password}
          errorPassword={this.state.errorPassword}
          passwordConfirmation={this.state.passwordConfirmation}
          errorPasswordConfirmation={this.state.errorPasswordConfirmation}
          logo={this.renderLogo}
        />
      );
    } else {
      return (
        <Username
          errors={errors}
          currentlySending={currentlySending}
          loading={loading}
          handleSubmit={this.handleSubmitUser}
          handleUsernameChange={this.handleUsernameChange}
          username={this.state.username}
          errorUsername={this.state.errorUsername}
          logo={this.renderLogo}
        />
      );
    }
  }
}

function mapStateToProps(state) {
  const { requests } = state;
  return {
    errors: requests.error,
    currentlySending: requests.currentlySending,
    loading: requests.loading,
    mfaChallenge: state.mfa.challenge,
    mfaStatus: state.mfa.status,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      passwordRequest,
      fetchMfaStatus,
      validateUsernameRequest,
      submitForgotPasswordChange,
      clearError,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotContainer);
